export const titles = [
  { title: 'Funnel name', maxWidth: 270 },
  { title: 'Number of steps', maxWidth: 120 },
  { title: 'Total conversations', maxWidth: 130 },
  { title: 'Completion rate', maxWidth: 120 },
  { title: '', maxWidth: 120 },
  { title: '', maxWidth: 20 },
]
